import { useMutation } from '@tanstack/react-query';
import { POST, POST_APPROVE_CLAIM } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { approveClaim } from '../../../../resources/payload';

export const useApproveClaim = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (value) => {
      const payload = approveClaim(value);
      const response = await POST(POST_APPROVE_CLAIM(), payload);
      return response;
    },
    onSuccess: (response) => {
      openAlert({ type: 'success', message: response?.message, model: 'message' });
      setTimeout(() => {
        navigateTo({ pathname: ROUTES_PATH.ROUTE_CLAIM.PATH });
      }, 1000);
    },
    onError: (error) => {
      openAlert({ type: 'error', message: error?.message, model: 'message' });
    },
  });
  return { mutate, loading: isPending };
};
